export default {
  allDestinations: [],
  offer: { cities: [] },
  selectedCode: '',
  prices: [],
  hotels: [],
  filterApply: {
    code: '',
    type: ''
  },
  datesFromLanding: {
    startDate: '',
    endDate: ''
  },
  formattedLocation: []

}
